var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { key: _vm.updatedAt },
    [
      _c("h1", [_vm._v("User Roles")]),
      _c("UserRoleEdit", {
        staticClass: "mb-3",
        attrs: {
          item: { settings: { menu: [], general: [], notifications: [] } },
        },
        on: { onAddItem: _vm.onEditItem },
      }),
      _c("top-table", {
        ref: "table",
        attrs: {
          "order-by": { column: "createdAt", ascending: 0 },
          headings: { createdAt: "Created On" },
          sortable: ["name", "createdAt"],
          columns: _vm.columns,
          url: "/user-roles",
          requestFunction: _vm.requestFunction,
          overlap: true,
        },
        scopedSlots: _vm._u([
          {
            key: "actions",
            fn: function (props) {
              return [
                _c(
                  "span",
                  { key: props.row._id, staticClass: "d-flex" },
                  [
                    _c("UserRoleEdit", {
                      attrs: { item: props.row },
                      on: { onEditItem: _vm.onEditItem },
                    }),
                    _c("UserRoleEdit", {
                      attrs: { action: "delete", item: props.row },
                      on: { onDeleteItem: _vm.onEditItem },
                    }),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "tools",
            fn: function (props) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      Object.keys(props.row.settings || {})
                        .map((key) =>
                          key === "_id" ? [] : props.row.settings[key]
                        )
                        .reduce((a, b) => [...a, ...b], [])
                        .join(",")
                    ) +
                    "\n    "
                ),
              ]
            },
          },
          {
            key: "createdAt",
            fn: function (props) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm._f("dateWithTime")(props.row.createdAt)) +
                    "\n    "
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }